// extracted by mini-css-extract-plugin
export default {"tree":"Extras_tree__lLcrT","extra":"Extras_extra__WuzEf"};